export function FounderSignatures({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-end gap-3 text-ink ${className}`} aria-label="Signed by Sagnik and Tanvi">
      <span className="signature-sagnik inline-block text-[2.35rem] leading-none">Sagnik</span>
      <span className="pb-1 font-hand text-xl text-muted" aria-hidden>+</span>
      <span className="signature-tanvi inline-block text-[2.45rem] leading-none">Tanvi</span>
    </div>
  );
}
